import { Matomo } from '~/common/helpers';

const CATEGORY = {
  PRICING_POLICY: 'ContainerPricingPolicy',
  ORDER: 'ContainerOrder',
  ORDER_STATUS_CHANGE: 'ContainerOrderStatusChange',
} as const;

const ACTION = {
  CREATE_PRICING_POLICY: 'create_pricing_policy',
  ORDER_CREATION: 'order_creation',
  ORDER_UPDATE: 'order_update',
  ORDER_VALIDATED: 'order_validated',
  ORDER_REFUSED: 'order_refused',
  ORDER_COMMENT_ADDED: 'order_comment_added',
  FILE_UPLOAD: 'file_upload',
} as const;

export function trackPricingPolicyCreated(policyId: string): void {
  Matomo.trackEvent(
    CATEGORY.PRICING_POLICY,
    ACTION.CREATE_PRICING_POLICY,
    policyId,
  );
}

export function trackOrderCreated(containerId: string): void {
  Matomo.trackEvent(CATEGORY.ORDER, ACTION.ORDER_CREATION, containerId);
}

export function trackOrderUpdated(containerId: string): void {
  Matomo.trackEvent(CATEGORY.ORDER, ACTION.ORDER_UPDATE, containerId);
}

export function trackOrderValidated(containerId: string): void {
  Matomo.trackEvent(
    CATEGORY.ORDER_STATUS_CHANGE,
    ACTION.ORDER_VALIDATED,
    containerId,
  );
}

export function trackOrderRefused(containerId: string): void {
  Matomo.trackEvent(
    CATEGORY.ORDER_STATUS_CHANGE,
    ACTION.ORDER_REFUSED,
    containerId,
  );
}

export function trackOrderCommentAdded(containerId: string): void {
  Matomo.trackEvent(CATEGORY.ORDER, ACTION.ORDER_COMMENT_ADDED, containerId);
}

export function trackFileUpload(): void {
  Matomo.trackEvent(CATEGORY.ORDER, ACTION.FILE_UPLOAD);
}
